import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiScoping } from '@/lib/api/scoping'
import { assessmentKeys } from '@/features/assessments/api/query-keys'

async function submitAssessment(id: string): Promise<void> {
  await apiScoping.patch(`/api/v1/plant-assessment/${id}`, {
    status: 'inProgress',
  })
}

export function useSubmitAssessment() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: submitAssessment,
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: assessmentKeys.lists() })
    },
  })
}
